import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { IonicModule } from '@ionic/angular';
import { IntegrityModule } from 'apps/idl/src/modules/integrity/integrity.module';

@NgModule({
	declarations: [],
	exports: [],
	imports: [
		CommonModule,
		IonicModule,
		MatListModule,
		IntegrityModule
	]
})
export class SeancesModule { }